import type { DeliveryMethodKind } from "@dransay/api/models";
import { VENDOR_PARAMS } from "~/utils/vendor";

interface BuildProductsHrefParams {
	searchParams: URLSearchParams;
	vendorId?: string;
	deliveryMethod?: DeliveryMethodKind;
}

export function buildProductsHref({
	searchParams,
	vendorId,
	deliveryMethod,
}: BuildProductsHrefParams): string {
	const params = new URLSearchParams(searchParams);
	params.delete("filters");
	params.delete("page");

	if (vendorId) {
		params.set(VENDOR_PARAMS.vendorId, vendorId);
	}
	if (deliveryMethod) {
		params.set(VENDOR_PARAMS.deliveryMethod, deliveryMethod);
	}

	const qs = params.toString();
	return `/products${qs ? `?${qs}` : ""}`;
}
